// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form__Form___1ClHk"};